<script>
	import { cheatsheets } from '../stores/cheatsheets.js';
	import { curSheet } from '../stores/curCheatsheet.js';
</script>

<div class="sidebar">
	{#each $cheatsheets as cheatsheet, index (cheatsheet.id)}
	<ul>
		<li>
			<div
				class:selected="{$curSheet.id === cheatsheet.id}"
				on:click={() => curSheet.selectSheet(cheatsheet)} class="cheatsheet">
				<p class="sidebar-title">{cheatsheet.title}</p>
				<p class="sidebar-tags">{cheatsheet.tags}</p>
			</div>
		</li>
	</ul>
	{/each}
</div>

<style>
	.cheatsheet {
		border: 2px solid grey;
		margin-right: 0;
	}

	.cheatsheet p {
		margin-left: 5px;
	}

	.selected {
		border: 2px solid #f57017;
		box-shadow: 10px 3px #647791;
	}

	ul {
		margin-top: 0;
		margin-bottom: 5px;
		list-style: none;
		padding: 0;
	}

	li {
		padding: 0;
	}

	.sidebar-title {
		display: inline-block;
		margin-bottom: 0;
		margin-left: 5px;
		margin-top: 8px;
	}
</style>